// extracted by mini-css-extract-plugin
export var articles = "articles-module--articles--00o2H";
export var articles__title = "articles-module--articles__title--rZCYu";
export var articles__container = "articles-module--articles__container--6SDRL";